import {Injectable} from '@angular/core';
import {Chart} from 'highcharts';
import {LineChartSettingsParameters} from '@models/charts/line-chart-settings-parameters';
import {ChartConstants} from '@constants/pages/chart-constants';
import { RangeType } from '@constants/pages/user-defined-page/range-type';
import { DAY_IN_MINUTES, HOUR_IN_MINUTES } from '@constants/pages/user-defined-page/time-constants';

@Injectable({
  providedIn: 'root'
})
export class LineChartDataUpdateService {

  public updateChartData(chart: Chart, parameters: LineChartSettingsParameters, values: any[]) {
    const seriesList = chart.series;
    if (!seriesList || seriesList.length === 0) {
      return;
    }

    for (const currentSeries of seriesList) {
      const signalId = currentSeries.options.id;
      if (!signalId || Number(signalId) <= 0) {
        continue;
      }
      for (const item of values) {
        const value = this.findSignalValueById(signalId, item.vs);
        if (value) {
          currentSeries.addPoint([item.ts, value], false);
        }
      }

      this.removeOldSeriesData(currentSeries, parameters.chartSettings);
    }

  }

  private findSignalValueById(signalId: string, values: any[]): number | undefined {
    for (const value of values) {
      if (value.s === signalId) {
        return Number(value.v);
      }
    }
    return undefined;
  }

  private removeOldSeriesData(series, chartSettings) {
    if (series.points.length === 0) {
      return;
    }

    let range = chartSettings.rangeValue;
    switch (chartSettings.rangeType) {
      case RangeType.HOUR : 
        range = chartSettings.rangeValue * HOUR_IN_MINUTES;
        break;
      case RangeType.DAY :
        range = chartSettings.rangeValue  * DAY_IN_MINUTES;
      }
    if (!range || range <= 0) {
      range = ChartConstants.MAX_INTERVAL_MINUTES;
    }
    const minTimeValue = Math.max(series.points[0].x, series.points[series.points.length - 1].x) - range * 60 * 1000;
    for (let i = 0; i < series.points.length; i++) {
      if (series.points[i].x < minTimeValue) {
        series.removePoint(i, false);
      }
    }

  }

}
